'use strict';

var Backbone = require('backbone'),

  Router = Backbone.Router.extend({
    userTrigger: function(params) {
      var url = window.location.pathname.substr(Backbone.history.root.length);
      this.navigate(url + '?' + params, {trigger: false});
    }
  }),

  OfficesRouterRouter = new Router();

module.exports = OfficesRouterRouter;



// WEBPACK FOOTER //
// ./assets/components/Offices/OfficesRouter.js